import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_TIMELINE_BANNER] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.timelinebanner = payload
  },
  [types.SET_TIMELINE_BANNERS] (state, payload) {
    state.timelinebanners = payload.data
    state.pagination = payload.meta.pagination
  }
}
